import React from 'react';
import ItemWithTooltip from './ItemWithTooltip';
import { TimelineScriptWrittenIcon } from '../../../Icons';

type Props = {
  item: any;
  isSimple: boolean;
  isExpanded: boolean;
};

const ScriptWrittenMedItem = ({ item, isSimple, isExpanded }: Props) => {
  return (
    <ItemWithTooltip item={item}>
      <div className="mt-2" />
      <TimelineScriptWrittenIcon />
    </ItemWithTooltip>
  );
};

export default ScriptWrittenMedItem;
